// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__WYgz_","logoBanner":"Banner_logoBanner__TgBIR","bannercontent":"Banner_bannercontent__3c_oJ","button":"Banner_button__2x5UV"};